import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/data';

const featuredArticles = allArticles.slice(0, 3);

export default function FeaturedArticlesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-14">
          <div>
            <p className="text-sm text-accent-600 font-medium tracking-widest mb-3">
              精选文章
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900">
              深度内容，用心呈现
            </h2>
          </div>
          <Link
            to="/category/core-value"
            className="inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs rounded-full font-medium">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 mb-4 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.author}</span>
                  <span>{article.date} · {article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}